import React from 'react';

import Card from '../Card/Card';
import styles from './actions-card.module.scss';

export default function ActionsCard({ children }: { children: JSX.Element }) {
  return (
    <div className={styles.cardContrainer}>
      <Card>
        {children}
      </Card>
    </div>
  );
}
